import { useState } from 'react'

import LeftMenu from './hamburger-left-menu'
import HamburgerMenu from './hamburger-menu'

export default function MobileMenu({
  isOnboardingCompleted,
  meData,
  meLoading,
}: {
  isOnboardingCompleted: boolean
  meData: any
  meLoading: boolean
}): JSX.Element {
  const [isOpen, setIsOpen] = useState(false)

  const toggleMenu = () => setIsOpen((open) => !open)

  return (
    <div className="lg:hidden ">
      {isOpen && !meLoading ? (
        <LeftMenu
          isOnboardingCompleted={isOnboardingCompleted}
          toggleMenu={toggleMenu}
          meData={meData}
        />
      ) : (
        <HamburgerMenu toggleMenu={toggleMenu} />
      )}
    </div>
  )
}
